import { titleCase as convertToTitleCase } from 'title-case';

/**
 *
 * @date 2022-04-19
 * @param {string} title - A string param
 * @returns {string}
 * @description param title is converted with title case and since letters after : and - need to capitalize, title is split and convertToTitle case
 * @example {}
 *    titleCase("A lemon is good"):
 *        return "A Lemon is good";
 *
 *    titleCase("A Vary is happy: the filming"):
 *        return ("A Vary is Happy: The filming");
 */
export const titleCase = (title) => {
  if (!title || typeof title !== 'string') {
    return '';
  }
  return title
    .toLowerCase()
    .split(': ')
    .map((item) => convertToTitleCase(item))
    .join(': ')
    .split(' - ')
    .map((item) => convertToTitleCase(item))
    .join(' - ');
};

export const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

/**
 * Decodes HTML entities in a given string.
 *
 * This function creates a temporary textarea element, sets its innerHTML to the
 * provided string, and then retrieves the decoded value from the textarea.
 *
 * @param {string} str - The string containing HTML entities to decode.
 * @returns {string} - The decoded string with HTML entities converted to their
 *                     corresponding characters.
 *
 * @example
 * decodeHTMLEntities("&lt;div&gt;Hello&lt;/div&gt;");
 * // returns "<div>Hello</div>"
 */
export const decodeHTMLEntities = (str) => {
  if (typeof window === 'undefined') return str;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

/**
 * Extracts the section title from an HTML string.
 *
 * This function takes an HTML string as input, decodes any HTML entities,
 * and uses a regular expression to find and return the content of the first
 * <h2> tag found within the decoded HTML. If no <h2> tag is found, it returns
 * undefined.
 *
 * @param {string} html - The HTML string containing the section title.
 * @returns {string|undefined} - The extracted section title or undefined if no <h2> tag is found.
 *
 * @example
 * const title = getSectionTitleFromHTML("<h2>My Section Title</h2>");
 * console.log(title); // Outputs: "My Section Title"
 */
export const getSectionTitleFromHTML = (html = '') => {
  const decoded = decodeHTMLEntities(html);
  const match = decoded.match(/<h2>(.*?)<\/h2>/i);
  return match && match[1];
};

export const getSlugFromUid = (uid) => {
  if (!uid) return '';
  // Spanish GC chapters live under /cs/...
  if (uid.startsWith('gc-es-')) {
    return `cs/${uid.replace(/^gc-es-/, 'grandecontroversia-')}`;
  }
  // English GC chapters
  return uid.replace(/^gc-/, 'greatcontroversy-');
};
